import { useLocation } from 'react-router-dom';

const usePathMatch = (path: string) => {
    const { pathname } = useLocation();

    const isExact = pathname === path;
    const isParent = !isExact && pathname.startsWith(path);
    const isChild = !isExact && path.startsWith(pathname);

    return { isExact, isParent, isChild };
};

export default usePathMatch;
